import type { BusinessUnit } from '@backend/lib-l10n';
import type { GetServerSidePropsContext, NextPageContext } from 'next';
import type { NextApiRequest } from 'next/dist/shared/lib/utils';
import type { ParsedUrlQuery } from 'querystring';

import { businessUnits } from '~/config/businessUnits';
import { getEnv } from '~/utils/env';
import { getParamValue } from '~/utils/params';

// `NEXT_PUBLIC_*` are inlined at build time, but the client bundle is built without the deploy env, so a
// module-level `process.env.NEXT_PUBLIC_…` const reads `undefined` in the browser. Read them through
// `getEnv` instead: `loadPublicEnv` (in `_app`) injects the server's runtime public env, so these resolve
// on both server and client — this is what makes the default a reliable fallback on client navigations.
export const getEnabledBusinessUnits = () =>
  getEnv('NEXT_PUBLIC_ENABLED_BUSINESS_UNITS', '').split(',').filter(Boolean);
export const getDefaultBusinessUnit = () => getEnv('NEXT_PUBLIC_DEFAULT_BUSINESS_UNIT') as BusinessUnit;

const isBusinessUnit = (maybeBusinessUnit: string): maybeBusinessUnit is BusinessUnit =>
  Object.keys(businessUnits).includes(maybeBusinessUnit);

export const isEnabledBusinessUnit = (businessUnit: BusinessUnit) => getEnabledBusinessUnits().includes(businessUnit);

export const extractBusinessUnit = (maybeBusinessUnit: string) =>
  isBusinessUnit(maybeBusinessUnit) ? maybeBusinessUnit : undefined;

export const extractBusinessUnitFromPath = (path: string) =>
  extractBusinessUnit(path.split('?')[0].split('/')[1]?.toUpperCase() ?? '');

export const extractBusinessUnitFromQuery = (query: ParsedUrlQuery) =>
  extractBusinessUnit(getParamValue(query?.businessUnit)?.toUpperCase() || '');

export const extractBusinessUnitFromContext = (context: GetServerSidePropsContext | NextApiRequest | NextPageContext) =>
  extractBusinessUnitFromQuery(context.query);
